var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnauthorized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    style: {
      margin: "0 auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3b54ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5L25.6 14.5 25.6 9.8C25.6 4.6 21.4 0.2 16.1 0.1 10.8 0 6.4 4.4 6.4 9.7L6.4 14.5 4 14.5C1.8 14.5 0 16.3 0 18.5L0 37.7C0 39.9 1.8 41.7 4 41.7L28 41.7C30.2 41.7 32 39.9 32 37.7L32 18.5C32 16.3 30.2 14.5 28 14.5ZM17.4 27L17.4 33.9C17.4 34.6 16.8 35.3 16.1 35.3 15.3 35.3 14.6 34.7 14.6 33.9L14.6 27C13.5 26.4 12.7 25.2 12.8 23.8 13 22.3 14.2 21 15.8 20.9 17.6 20.8 19.2 22.3 19.2 24.1 19.2 25.4 18.5 26.5 17.4 27ZM22.8 14.5L9.2 14.5 9.2 9.7C9.2 7.9 9.9 6.2 11.2 4.9 12.5 3.6 14.2 2.9 16 2.9 17.8 2.9 19.5 3.6 20.8 4.9 22.1 6.2 22.8 7.9 22.8 9.7L22.8 14.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.68910cd7b49cbf30c3dbbf5d532f1825.svg";
export { ForwardRef as ReactComponent };